export const getActiveView = (pathname) => {
  if (pathname.includes('/complaints')) return 'complaints';
  if (pathname.includes('/readings')) return 'readings';
  if (pathname.includes('/edit-profile')) return 'edit-profile';
  if (pathname.includes('/users')) return 'users';
  if (pathname.includes('/devices')) return 'devices';
  if (pathname.includes('/emission-points')) return 'emission-points';
  if (pathname.includes('/incidents')) return 'incidents';
  if (pathname.includes('/warnings')) return 'warnings';
  if (pathname.includes('/concentrations')) return 'concentrations';
  return 'map';
};